import React, { FC } from 'react';
import { Card } from 'src/common';
import styles from './index.module.scss';
import AdminCompaniesForm from './AdminCompaniesForm';
import AdminCompaniesList from './AdminCompaniesList';

interface IProps {
  loading?: boolean;
  addOrgsLoading?: boolean;
  orgNumbers: string[];
  addOrgs: (selectedIds: string[], updatingIds: string[]) => void;
  removeOrgs: (selectedIds: string[], updatingIds: string[], onComplete: () => void) => void;
}
export const AdminCompaniesFilter: FC<IProps> = props => {
  const { orgNumbers, addOrgs, removeOrgs, loading, addOrgsLoading } = props;

  return (
    <Card loading={!!loading} custom={true} className={styles.companiesFilter}>
      <AdminCompaniesForm orgNumbers={orgNumbers} addOrgs={addOrgs} addOrgsLoading={addOrgsLoading} />
      <AdminCompaniesList orgNumbers={orgNumbers} removeOrgs={removeOrgs} />
    </Card>
  );
};

export default AdminCompaniesFilter;
